/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FixedPriceProjectDetailsResourceAllOfQuoteLines } from './';
import {
    FixedPriceProjectDetailsResourceAllOfQuoteLinesFromJSON,
    FixedPriceProjectDetailsResourceAllOfQuoteLinesFromJSONTyped,
    FixedPriceProjectDetailsResourceAllOfQuoteLinesToJSON,
} from './';
import type { ProjectDetailsResource } from './';
import {
    ProjectDetailsResourceFromJSON,
    ProjectDetailsResourceFromJSONTyped,
    ProjectDetailsResourceToJSON,
} from './';
import type { ProjectType } from './';
import {
    ProjectTypeFromJSON,
    ProjectTypeFromJSONTyped,
    ProjectTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface FixedPriceProjectDetailsResource
 */
export interface FixedPriceProjectDetailsResource extends ProjectDetailsResource {
    /**
     * 
     * @type {Array<FixedPriceProjectDetailsResourceAllOfQuoteLines>}
     * @memberof FixedPriceProjectDetailsResource
     */
    quoteLines: Array<FixedPriceProjectDetailsResourceAllOfQuoteLines>;
    /**
     * 
     * @type {string}
     * @memberof FixedPriceProjectDetailsResource
     */
    additionalNotes?: string;
}

/**
 * Check if a given object implements the FixedPriceProjectDetailsResource interface.
 */
export function instanceOfFixedPriceProjectDetailsResource(value: object): value is FixedPriceProjectDetailsResource {
    if (!('quoteLines' in value) || value['quoteLines'] === undefined) return false;
    return true;
}

export function FixedPriceProjectDetailsResourceFromJSON(json: any): FixedPriceProjectDetailsResource {
    return FixedPriceProjectDetailsResourceFromJSONTyped(json, false);
}

export function FixedPriceProjectDetailsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FixedPriceProjectDetailsResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectDetailsResourceFromJSONTyped(json, ignoreDiscriminator),
        'quoteLines': ((json['quoteLines'] as Array<any>).map(FixedPriceProjectDetailsResourceAllOfQuoteLinesFromJSON)),
        'additionalNotes': json['additionalNotes'] == null ? undefined : json['additionalNotes'],
    };
}

export function FixedPriceProjectDetailsResourceToJSON(value?: FixedPriceProjectDetailsResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectDetailsResourceToJSON(value, true),
        'quoteLines': ((value['quoteLines'] as Array<any>).map((v) => FixedPriceProjectDetailsResourceAllOfQuoteLinesToJSON(v))),
        'additionalNotes': value['additionalNotes'],
    };
}

